import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';

const DashboardSection = ({ 
  title, 
  icon: Icon, 
  defaultExpanded = false, 
  children, 
  onExpand 
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    if (newState && onExpand) {
      onExpand();
    }
  };

  return (
    <Card className="mb-4">
      <div
        onClick={handleToggle}
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center space-x-3">
          {Icon && (
            <div className="p-2 bg-[#00B4D8] bg-opacity-10 rounded-lg">
              <Icon className="h-5 w-5 text-[#00B4D8]" />
            </div>
          )}
          <h3 className="text-lg font-semibold text-[#2B2D42]">{title}</h3>
        </div>
        <button className="p-2 hover:bg-gray-200 rounded-lg transition-colors">
          {isExpanded ? (
            <ChevronUp className="h-5 w-5 text-[#6C757D]" />
          ) : (
            <ChevronDown className="h-5 w-5 text-[#6C757D]" />
          )}
        </button>
      </div>
      
      {isExpanded && (
        <CardContent className="pt-0 pb-6">
          <div className="border-t border-gray-200 pt-4">
            {children}
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default DashboardSection;
